<div class="h-full flex gap-4 mx-2 justify-center">
  <div *ngIf="isNeedScroll" class="flex items-center max-h-[500px] mr-[1vw] mobile:mr-0 mobile:max-h-[270px]"
       [class.disabled-arrow]="isAtStart">
    <mat-icon class="hover:scale-[1.08]" (click)="goLeft()">chevron_left</mat-icon>
  </div>
  <div #container *ngIf="{data: data$ | async, settings: frontendSettings$ | async} as vm"
       class="flex gap-4 overflow-x-auto w-fit max-w-full h-full p-2 max-h-[500px] scroll-smooth mobile:max-h-[270px]"
       h-scroll>
    <ig-visitor-fancy-card #card *ngFor="let item of vm.data;let i = index;trackBy:trackByIndex"
                           [attr.socialName]="item.socialName" [item]="item" [allItems]="vm.data"
                           [editorChoiceText]="vm.settings.customSettings.customEditorChoice"
                           [favCustomEvents]="vm.settings.customSettings.customEvents"
                           [detailsPageStyle]="vm.settings.customSettings.calendarStyle.eventDetails"></ig-visitor-fancy-card>
  </div>
  <div *ngIf="isNeedScroll" class="flex items-center max-h-[500px] ml-[1vw] mobile:ml-0 mobile:max-h-[270px]"
       [class.disabled-arrow]="isAtEnd">
    <mat-icon class="hover:scale-[1.08]" (click)="goRight()">chevron_right</mat-icon>
  </div>
</div>
